import React from "react";
import { Card, Col, Form, Row } from "react-bootstrap";
import { SlEnergy } from 'react-icons/sl';
import { TbFlame } from 'react-icons/tb';
import { MdOutlineOilBarrel } from 'react-icons/md';


/**
 * SwitchAnlageCard
 * 
 * AnlageCard for Leerstand Anmelden/Abmelden for Hausemanagement
 * 
 * used in /pages/hw/LeerstandPage
 * 
 * @param {anlage, selected, setSelected} props anlage data, selected: list of anlage ids which has been selected, setSelected: function to change selected list
 * @returns html
 */
const SwitchAnlageCard = (props) => {

    const id = props.anlage.id; // id from anlage

    let headerBg = ""; // background color of card header

    // checks anlage type and changes header background color
    if (props.anlage) {
        if (props.anlage.x_studio_field_3eKe0 === "Strom") headerBg = '#a2c13f';
        if (props.anlage.x_studio_field_3eKe0 === "Gas") headerBg = '#3fbfbf';
        if (props.anlage.x_studio_field_3eKe0 === "Oil") headerBg = '#a2c13f';
    }

    
    // when card switch is triggered
    const switchHandler = (val) => {
        if (props.selected.length > 0) {  // check if selected list has elements
            if (!props.selected.includes(id)) {  // if selected list does not have id from this anlage
                props.setSelected([...props.selected, id]); // add id from this anlage to the list

            } else { // if selected list has id, remove it from selected list
                let new_arr = [...props.selected];
                new_arr.splice(new_arr.indexOf(id), 1);
                props.setSelected(new_arr);
            }
        } else { // if selected list is empty add this anlage id
            props.setSelected([id]);
        }
    }

    // GUI
    return (
        <Col xs="12" xl="8">
            {props.anlage ?
                <Card className="mt-3 shadow-lg">
                    <Card.Header className="text-start" style={props.anlage.x_studio_field_Xhbek.length > 0 || !props.anlage.x_studio_field_Xhbek ? { backgroundColor: headerBg } : { backgroundColor: "#c0c2bc" }}>
                        <Row>
                            <Col xs="4">
                                <b>
                                    {props.anlage.x_studio_field_3eKe0 === "Strom" ? <SlEnergy /> : null}
                                    {props.anlage.x_studio_field_3eKe0 === "Gas" ? <TbFlame /> : null}
                                    {props.anlage.x_studio_field_3eKe0 === "Oil" ? <MdOutlineOilBarrel /> : null}
                                    &nbsp;
                                    Anlage: {props.anlage.x_studio_field_3eKe0}
                                </b>
                            </Col>
                            <Col xs="8 text-end">
                                {props.anlage.x_studio_field_Xhbek.length>0 ?
                                    (`Aktueller Vertragspartner: ${props.anlage.x_studio_field_Xhbek[1]}`)
                                    : ("Aktuell nicht bei ENERGO angemeldet")
                                }
                            </Col>
                        </Row>
                    </Card.Header>
                    <Card.Body className="text-start">
                        <Row className="align-items-center">
                            <Col  sm="8" md="8" lg="8">
                                <small>- Anlagennummer ENERGO: {props.anlage.x_studio_field_mWMGR}</small><br />
                                <small>- Zählernummer: {props.anlage.x_zaehlernummer_01}</small><br />
                                <small>- Zählpunktnummer: {props.anlage.x_zaehlpunktnummer_01}</small><br />
                                <small>{props.anlage.x_lastprofil_01 !== "False" ? "- Lastprofil: " + props.anlage.x_lastprofil_01 : ""}</small>
                                {props.anlage.x_zaehlpunktnummer_02 ?
                                    <small>
                                        <hr />
                                        - Zählernummer: {props.anlage.x_zaehlernummer_02} <br />
                                        - Zählpunktnummer: {props.anlage.x_zaehlpunktnummer_02} <br />
                                        {props.anlage.x_lastprofil_02 !== "False" ? "- Lastprofil: " + props.anlage.x_lastprofil_02 : ""}
                                    </small>
                                    : null}
                            </Col>
                            <Col  sm="4" md="4" lg="4" className="text-center">
                                <Form.Check
                                    style={{ height: "2.5em!important" }}
                                    type="switch"
                                    id="switch"
                                    onChange={e => switchHandler(e.target.checked)}
                                    defaultChecked={
                                        props.anlage.x_studio_field_Xhbek[0] !== props.top.x_gebaeude_id[0] || props.anlage.x_studio_field_Xhbek.length === 0?
                                            false : true
                                    }
                                    
                                />
                            </Col>
                        </Row>
                    </Card.Body>
                </Card>
                : null
            }
        </Col>
    )
}

export default SwitchAnlageCard;